import React, { useEffect, useState } from "react";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

const TawkChat = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof navigator !== "undefined" && navigator.webdriver) return undefined;
    const start = () => setReady(true);
    if (typeof window.requestIdleCallback === "function") {
      const id = window.requestIdleCallback(start, { timeout: 5000 });
      return () => window.cancelIdleCallback(id);
    }
    const timer = window.setTimeout(start, 4000);
    return () => window.clearTimeout(timer);
  }, []);

  if (!ready) return null;
  return (
    <TawkMessengerReact
      propertyId="627379ad7b967b11798dde13"
      widgetId="1g29h6ji8"
    />
  );
};

export default TawkChat;
